/**
 * This isn't database-id-level random (and should not be used as such), but random enough for keys and validation
 * Consider using React's useId where possible.
 */
export const generateRandomKey = (prefix?: string) => {
    return `${prefix ?? ''}${Math.floor(Math.random() * 9999999)}`
}

/**
 * This isn't database-id-level random (and should not be used as such)
 * Generate a random id that can be used as html id
 */
export const generateRandomStringKey = (length = 10): string => {
    let randomId = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length)
        randomId += characters[randomIndex]
    }

    return randomId
}
